import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Http, Headers, RequestOptions } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';
import { LoadingProvider } from '../../providers/loading/loading';
import {EnvDataService} from '../../app/services/env-data-service';
import { ADFFormService } from '../adf-page/services/adf-form.service';
@Component({
  selector: 'adf-allow-customer-permission',
  templateUrl: 'adf-customer-permission.html',
  providers:[EnvDataService,ADFFormService]
})
export class AdfCustomerPermissionPage {

  public accessPermissioncheckstatus : any;
  public accessPermissionname : any;
  public accessPermissioncheckstatusPS : any;
  public accessPermissionnamePS : any;
  public userRole: any;
  public allowCustomerEditPermissionStatus: any;
  public allowCustomerViewOnlyPermissionStatus: any;
  public contact_uid: any;
  public SDF_form_document_id: any;
  public accessPermission: any;
  public allowCustoeditPermission: any;
  public allowCustoViewOnlyPermission: any;
  public viewOnlyPermissionName: any;
  public editPermissionName: any;
  public reference_broker_uid: any;
  public broker_email: any;
  public customer_email: any;
  public customer_password: any;
  public firstname:any;
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public http : Http,
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public viewCtrl: ViewController,
    public db: AngularFirestore,
    private EnvDataService:EnvDataService,
    private ADFFormService:ADFFormService
  ) {
    this.broker_email = '';
    this.contact_uid = this.navParams.get("contact_uid");
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    this.allowCustoeditPermission = this.navParams.get("allowCustoeditPermission");
    this.allowCustoViewOnlyPermission = this.navParams.get("allowCustoViewOnlyPermission");
    this.customer_email = this.navParams.get("customer_email");
    this.customer_password = this.navParams.get("customer_password");
    this.broker_email = this.navParams.get("broker_email");
    this.firstname = this.navParams.get("firstname");
    console.log(this.contact_uid);
    console.log(this.SDF_form_document_id);
 
    // this.getcustomerPermission().subscribe((data)=>{
    //   debugger;
    //   if(data.length > 0){
    //     this.allowCustoeditPermission = data[0].allowCustoeditPermission;
    //     this.allowCustoViewOnlyPermission = data[0].allowCustoViewOnlyPermission;
    //     if(this.allowCustoeditPermission == 1){
    //       this.editPermissionName = 'Disallow Customer Edit Permissions';
    //     }else{
    //       this.editPermissionName = 'Allow Customer Edit Permissions';
    //     }
    //     if(this.allowCustoViewOnlyPermission == 1){
    //       this.viewOnlyPermissionName = 'Disallow Customer View Only Permissions';
    //     }else{
    //       this.viewOnlyPermissionName = 'Allow Customer View Only Permissions';
    //     }
    //     this.getUserDetails(data[0].uid).subscribe((uData)=>{
    //       if(uData.length > 0){
    //         this.customer_email = uData[0].email;
    //         this.customer_password = uData[0].password;
    //       }
    //     });
    //     this.reference_broker_uid = data[0].reference_broker;
    //     if(this.reference_broker_uid == "" || this.reference_broker_uid == null || this.reference_broker_uid == undefined){}else{
    //       this.getBrokerDetails().subscribe((broker_data)=>{
    //         if(broker_data.length > 0){
    //           this.broker_email = broker_data[0].email;
    //         }
    //       });
    //     }

    //   }
    // }); 


    // this.allowCustoeditPermission = this.navParams.get("allowCustoeditPermission");
    // this.allowCustoViewOnlyPermission = this.navParams.get("allowCustoViewOnlyPermission");

    if(this.allowCustoeditPermission == 1){
      this.editPermissionName = 'Disallow Customer Edit Permissions';
    }else{
      this.editPermissionName = 'Allow Customer Edit Permissions';
    }
    if(this.allowCustoViewOnlyPermission == 1){
      this.viewOnlyPermissionName = 'Disallow Customer View Only Permissions';
    }else{
      this.viewOnlyPermissionName = 'Allow Customer View Only Permissions';
    }
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad AllowCustomerPermissionPage');
  }

  getcustomerPermission (){
    return this.db.collection<any>( "users_data" , ref => ref.where('uid','==',this.contact_uid ).where('SDF_form_document_id','==',this.SDF_form_document_id )).valueChanges ();
  }

  getUserDetails(uid){
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',this.contact_uid )).valueChanges ();
  }

  getBrokerDetails (){
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',this.reference_broker_uid )).valueChanges ();
  }

  closePopover(){
    // window.localStorage.removeItem("contact_uid");
    // window.localStorage.removeItem("contact_second_uid");
    let data = {
      allowCustoeditPermission:this.allowCustoeditPermission,
      allowCustoViewOnlyPermission:this.allowCustoViewOnlyPermission
    }
    this.viewCtrl.dismiss(data);
  }

  allowCustomerEditPermission(event){
    this.loadingProvider.startLoading();
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    const requestOptions = new RequestOptions({ headers: headers });
    this.allowCustomerEditPermissionStatus = 1;
    if(this.allowCustoeditPermission == 1){
      this.allowCustomerEditPermissionStatus = 0;
    }
    
    let postData = {
      'contact_uid' : this.contact_uid,
      'SDF_form_document_id' : this.SDF_form_document_id,
      'customer_email': this.customer_email,
      'customer_password': this.customer_password,
      'broker_email' : this.broker_email,
      'allowCustoeditPermission': this.allowCustomerEditPermissionStatus
    }
    console.log(postData);
    var url = this.EnvDataService.EnvData.sendbox_api+"/allowCustomerEditPermission";
    this.http.post(url, postData, requestOptions)
    .subscribe(data => {
      console.log(data['_body']);
      if(data['_body'] == 'success'){
        if(this.allowCustomerEditPermissionStatus == 1){
          this.presentToast('Allow edit access to customer.');
          this.allowCustoeditPermission = 1;
          this.editPermissionName = 'Disallow Customer Edit Permissions';
        }else{
          this.presentToast('Disallow edit access to customer.');
        }        
      }else{
        this.presentToast('Something went wrong please try again later.');
      }
      this.loadingProvider.stopLoading();
    }, error => {
      console.log(error.message);
      this.loadingProvider.stopLoading();
    });
  }

  allCustomerAdfedit() {

    this.loadingProvider.startLoading();

    this.allowCustomerEditPermissionStatus = 1;
    if(this.allowCustoeditPermission == 1){
      this.allowCustomerEditPermissionStatus = 0;
    }

    let data = {
      'contact_uid' : this.contact_uid,
      'SDF_form_document_id' : this.SDF_form_document_id,
      'customer_email': this.customer_email,
      'customer_password': this.customer_password,
      'broker_email' : this.broker_email,
      'allowCustoeditPermission': this.allowCustomerEditPermissionStatus
    }

    let thiss = this;

    this.ADFFormService.updateAdfEditPermission(data).then((data) => {
    
        let postData = {
          'firstname':this.firstname,
          'contact_uid' : this.contact_uid,
          'SDF_form_document_id' : this.SDF_form_document_id,
          'customer_email': this.customer_email,
          'customer_password': this.customer_password,
          'broker_email' : this.broker_email,
          'allowCustoeditPermission': this.allowCustomerEditPermissionStatus
        }
        console.log(postData);
        var url = this.EnvDataService.EnvData.sendbox_api+"/adfCustomerEditPermission";

        var headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json' );
        const requestOptions = new RequestOptions({ headers: headers });

        this.http.post(url, postData, requestOptions)
        .subscribe(data => {
          console.log(data['_body']);
          if(data['_body'] == 'success'){
            if(thiss.allowCustomerEditPermissionStatus == 1){
              thiss.presentToast('Allow edit access to customer.');
              thiss.allowCustoeditPermission = 1;
              thiss.editPermissionName = 'Disallow Customer Edit Permissions';
              
            }else{
              thiss.presentToast('Disallow edit access to customer.');
              thiss.allowCustoeditPermission = 0;
              thiss.editPermissionName = 'Allow Customer Edit Permissions';
             
            } 

            thiss.loadingProvider.stopLoading();
            thiss.closePopover();

          }else{
            console.log(data);
            thiss.presentToast('Something went wrong please try again later.');

            thiss.loadingProvider.stopLoading();
            thiss.closePopover();
          }
          

        }, error => {
          console.log(error.message);
          thiss.loadingProvider.stopLoading();
        });

       
    })


  }

  allowCustomerViewOnlyPermission(event){
    this.loadingProvider.startLoading();
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    const requestOptions = new RequestOptions({ headers: headers });
    this.allowCustomerViewOnlyPermissionStatus = 1;
    if(this.allowCustoViewOnlyPermission == 1){
      this.allowCustomerViewOnlyPermissionStatus = 0;
    }
    let postData = {
      'contact_uid' : this.contact_uid,
      'SDF_form_document_id' : this.SDF_form_document_id,
      'customer_email': this.customer_email,
      'customer_password': this.customer_password,
      'broker_email' : this.broker_email,
      'allowCustoViewOnlyPermission': this.allowCustomerViewOnlyPermissionStatus
    }
    var url = this.EnvDataService.EnvData.sendbox_api+"/allowCustomerViewOnlyPermission";
    this.http.post(url, postData, requestOptions)
    .subscribe(data => {
      console.log(data['_body']);
      if(data['_body'] == 'success'){
        if(this.allowCustomerViewOnlyPermissionStatus == 1){
          this.presentToast('Allow view only access to customer.');
        }else{
          this.presentToast('Disallow view only access to customer.');
        }        
      }else{
        this.presentToast('Something went wrong please try again later.');
      }
      this.loadingProvider.stopLoading();
    }, error => {
      console.log(error.message);
      this.loadingProvider.stopLoading();
    });
  }

  allowCustomerAdfOnlyPermission(event) {

    this.loadingProvider.startLoading();

    this.allowCustomerViewOnlyPermissionStatus = 1;
    if(this.allowCustoViewOnlyPermission == 1){
      this.allowCustomerViewOnlyPermissionStatus = 0;
    }

    let data = {
      'contact_uid' : this.contact_uid,
      'SDF_form_document_id' : this.SDF_form_document_id,
      'customer_email': this.customer_email,
      'customer_password': this.customer_password,
      'broker_email' : this.broker_email,
      'allowCustoViewOnlyPermission': this.allowCustomerViewOnlyPermissionStatus
    }

    let thiss = this;

    this.ADFFormService.updateAdfViewPermission(data).then((data) => {
    
        let postData = {
          'firstname':this.firstname,
          'contact_uid' : this.contact_uid,
          'SDF_form_document_id' : this.SDF_form_document_id,
          'customer_email': this.customer_email,
          'customer_password': this.customer_password,
          'broker_email' : this.broker_email,
          'allowCustoViewOnlyPermission': this.allowCustomerViewOnlyPermissionStatus
        }
        console.log(postData);
        var url = this.EnvDataService.EnvData.sendbox_api+"/adfCustomerViewPermission";

        var headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json' );
        const requestOptions = new RequestOptions({ headers: headers });

        this.http.post(url, postData, requestOptions)
        .subscribe(data => {
          console.log(data['_body']);
          if(data['_body'] == 'success'){
            if(thiss.allowCustomerViewOnlyPermissionStatus == 1){
              thiss.presentToast('Allow view only access to customer.');
              thiss.allowCustoViewOnlyPermission = 1;
              thiss.viewOnlyPermissionName = 'Disallow view only access to customer.';
              
            }else{
              thiss.presentToast('Disallow view only access to customer.');
              thiss.allowCustoViewOnlyPermission = 0;
              thiss.viewOnlyPermissionName = 'Allow view only access to customer.';
             
            } 

            thiss.loadingProvider.stopLoading();
            thiss.closePopover();

          }else{
            console.log(data);
            thiss.presentToast('Something went wrong please try again later.');

            thiss.loadingProvider.stopLoading();
            thiss.closePopover();
          }
          

        }, error => {
          console.log(error.message);
          thiss.loadingProvider.stopLoading();
        });

       
    })

  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  

}



// WEBPACK FOOTER //
// ./src/pages/adf-customer-permission/adf-customer-permission.ts